export const RESOURCE_HAS_ACTIVE_SUBTASK = 'RESOURCE_HAS_ACTIVE_SUBTASK';
